import { Team } from "../../../types/team";
import { EntitySelectionProps } from "../EntitySelectionInput";
import EntitySelectionModal from "../../modals/EntitySelectionModal";
import useTeamQuery from "../../../hooks/query/useTeamQuery";
import useTeamLogic from "../../../hooks/logic/teamLogic";

interface TeamSelectionModalProps extends EntitySelectionProps<Team> {
  systemLanguageType: Team["system_language_type"];
}

export const TeamSelectionModal: React.FC<TeamSelectionModalProps> = ({
  open,
  initialSelectedEntity,
  onClose,
  handleEntitySelect,
  systemLanguageType,
  required,
}) => {
  const { useFetchAll } = useTeamQuery(systemLanguageType);
  const { languageBasedColumns } = useTeamLogic(systemLanguageType);
  const { data, isLoading, pagination, setPagination, errorMessage } =
    useFetchAll({
      enabled: open,
      filters: { system_language_type: systemLanguageType },
    });

  return (
    <EntitySelectionModal
      open={open}
      onClose={onClose}
      title="Select Teams"
      columns={languageBasedColumns}
      data={data?.data || []}
      error={errorMessage}
      loading={isLoading}
      pagination={pagination}
      onPaginationChange={setPagination}
      onSelect={handleEntitySelect}
      totalRowCount={data?.total || 0}
      initialSelectedEntity={initialSelectedEntity}
      required={required}
    />
  );
};

const renderTeamSelection =
  (systemLanguageType: Team["system_language_type"]) =>
  (props: EntitySelectionProps<Team>) => (
    <TeamSelectionModal {...props} systemLanguageType={systemLanguageType} />
  );

export default renderTeamSelection;
